// extracted by mini-css-extract-plugin
module.exports = {"textRed":"RestablecerContrasena_textRed__1BwhC","textCenter":"RestablecerContrasena_textCenter__2khpB","formContainer":"RestablecerContrasena_formContainer__2VwWe"};